
import Moderator from '@/models/bread/Moderator/eventInvitedPlayer'


export default {
    key: 'EventInvitedPlayer',
    name: {
        singular: 'InvitedPlayer',
        plural: 'InvitedPlayers',
    },
    parents: [
        'Event',
    ],
    Admin: false,
    Moderator: Moderator,
    Teacher: false,
}